import type { MarketplaceEntityWithStatus, RecursiveArg } from './types';

type Props = RecursiveArg | RecursiveArg[] | undefined;

export default function useMentionedMarketplaceEntities(objectWithMarketplaceEntities: Props): {
  mentionedMarketplaceEntities: MarketplaceEntityWithStatus[];
} {
  const marketplaceEntities: Record<string, MarketplaceEntityWithStatus> = {};
  const recursivelyGetMarketplaceEntities = (child: Props) => {
    if (!child) {
      return null;
    }
    if (Array.isArray(child)) {
      child.forEach(nestedChild => recursivelyGetMarketplaceEntities(nestedChild));
    } else if (typeof child === 'object' && child !== null) {
      if ('marketplaceField' in child && !marketplaceEntities[child.id]) {
        const entity = child.marketplaceField;
        marketplaceEntities[`${child.id}-${child.field}`] = {
          id: child.id,
          displayName: entity.name,
          isActive: entity.isActive,
          field: child.field,
        };
      }
      Object.keys(child).forEach(nestedKey =>
        recursivelyGetMarketplaceEntities(
          (child as unknown as Record<string, RecursiveArg>)[nestedKey],
        ),
      );
    }
  };
  recursivelyGetMarketplaceEntities(objectWithMarketplaceEntities);
  const mentionedMarketplaceEntities = Object.values(marketplaceEntities);
  return { mentionedMarketplaceEntities };
}
